export default __webpack_public_path__ + "343f965657c58361f511b9200deb4eda.png";